import React, { useContext, useEffect, useState } from 'react'
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { MdCheck, MdDelete } from 'react-icons/md';
import { Button, IconButton, Tooltip } from '@mui/material';
import { CgToggleOff, CgToggleSquareOff } from "react-icons/cg";
import { BsToggle2Off, BsToggle2On } from 'react-icons/bs';
import bedApi from '../../../api/bedApi';

const BedActivateForm = ({ id, isActive, refreshGrid, disabled }) => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);
    const [openBedActivate, setOpenBedActivate] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    useEffect(() => {

    }, []);
    const handleOpenBedActivate = (id) => {
        setOpenBedActivate(true);
    };
    const handleBedActivate = () => {
        setSubmitLoading(true);
        bedApi.BedActivate(id, isActive).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                refreshGrid(true)
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => { setOpenBedActivate(false); setSubmitLoading(false); });
    };
    return (
        <div>
            {/* <Button variant='contained' disabled={disabled} onClick={() => {
                handleOpenBedActivate(id)
            }}>
                {isActive ? "فعال" : "غیرفعال"}
            </Button> */}
            <Tooltip title={isActive ? "فعال" : "غیرفعال"} placement="top">
                <IconButton onClick={() => {
                    handleOpenBedActivate(id)
                }}>
                    {isActive ? <BsToggle2On size={25} color='green' /> : <BsToggle2Off size={25} color='gray' />}
                </IconButton>
            </Tooltip>
            <ConfirmationDialog
                open={openBedActivate}
                handleClose={() => setOpenBedActivate(false)}
                func={handleBedActivate}
                title={isActive ? "آیا از فعال سازی این تخت اطمینان دارید؟" : "آیا از غیرفعال سازی این تخت اطمینان دارید؟"}
                loading={submitLoading}
            />
        </div>
    )
}

export default BedActivateForm